import { render, staticRenderFns } from "./complianceMonitor.vue?vue&type=template&id=22bdfb1b&scoped=true&"
import script from "./complianceMonitor.vue?vue&type=script&lang=js&"
export * from "./complianceMonitor.vue?vue&type=script&lang=js&"
import style0 from "./complianceMonitor.vue?vue&type=style&index=0&id=22bdfb1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdfb1b",
  null
  
)

export default component.exports